import React from "react";
import { GoogleMap, LoadScript, MarkerF } from "@react-google-maps/api";
import { Box } from "@mui/material"; // Import Box for semantic HTML wrapper

const containerStyle = {
  width: "100%",
  height: "65vh",
};

const center = {
  lat: 33.99736,
  lng: -118.39609,
};

function Map() {
  return (
    // Use <Box component="section"> to give the map a semantic container
    <Box
      component="section"
      aria-label="Map showing the location of Shawns Christmas Trees at 11111 Jefferson Blvd, Culver City, CA 90230"
      role="region" // Role to define the content as a region on the page
      sx={{ width: "100%" }}
    >
      <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY}>
        <GoogleMap 
          mapContainerStyle={containerStyle} 
          center={center} 
          zoom={13}
          // The title provides a brief description for crawlers and non-map users
          options={{
            mapId: 'YOUR_MAP_ID', // Optional: Use a custom map ID for styling/SEO if configured in Google Cloud
          }}
        >
          {/* Child components, such as markers, info windows, etc. */}
          <MarkerF 
            position={center} 
            label={"Shawns Christmas Trees"} 
            title="Shawns Christmas Trees Lot Location" // Title attribute for better context
          />
          <></>
        </GoogleMap>
      </LoadScript>
    </Box>
  );
}

export default React.memo(Map);